import { Link } from "react-router-dom";
import { blogArticleSlug, blogArticleExcerpt, allBlogArticles } from "@/mocks/blogContent";

export default function AboutSection() {
  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
        {/* Left: Image */}
        <div className="lg:w-2/5 w-full">
          <div className="relative">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/60 text-xs font-medium text-foreground-700 bg-white mb-6">
              SEO Guide 2026
            </span>
            <div className="w-full h-72 md:h-96 rounded-[40px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20scene%20with%20a%20neatly%20organized%20desk%20featuring%20laptop%20displaying%20data%20dashboard%20alongside%20curated%20fashion%20items%20folded%20clothing%20and%20sneakers%20warm%20creamy%20natural%20sunlight%20streaming%20through%20window%20clean%20editorial%20photography%20with%20soft%20shadows%20organic%20composition&width=800&height=700&seq=mulebuy-about-img-x2&orientation=portrait"
                alt="Mulebuy spreadsheet guide"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Right: Content */}
        <div className="lg:w-3/5 w-full">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            What Is Mulebuy
            <br />
            Spreadsheet?
            <br />
            Complete 2026 Guide
          </h2>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
            {blogArticleExcerpt}
          </p>
          <Link
            to={`/blog/${blogArticleSlug}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-white font-medium text-sm hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            Read Full Guide
            <span className="w-5 h-5 flex items-center justify-center rounded-full bg-white/20">
              <i className="ri-arrow-right-line text-xs"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}